<template>
  <form
    ref="form"
    data-url="/evaluator/evaluationPlan/preparation"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >1. TIPO DE ORGANISMO DE EVALUACIÓN DE LA CONFORMIDAD (OEC):</label
          >
          <p class="text-muted mt-2">Prueba</p>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>2. NOMBRE DEL ORGANISMO EVALUADO:</label>
          <p class="text-muted mt-2">{{ org.name }}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>EXPEDIENTE Nº:</label>
          <p class="text-muted mt-2">{{ accApp.record }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>CIUDAD, PAIS:</label>
          <p class="text-muted mt-2">
            {{ org.canton ? org.canton.name : org.city }},
            {{ org.country.name }}
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>DIRECCIÓN:</label>
          <p class="text-muted mt-2">{{ org.address }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>TELEFONO:</label>
          <p class="text-muted mt-2">{{ org.phone }}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>EMAIL:</label>
          <p class="text-muted mt-2">{{ org.email }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>PERSONA RESPONSABLE POR LA ACREDITACIÓN:</label>
          <p class="text-muted mt-2">{{ org.legal_representative }}</p>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>3. LUGAR DE LA EVALUACIÓN</label>
          <app-input
            type="text"
            v-model="inputs.place_evaluation"
            :required="true"
            placeholder="Ingrese el lugar de la evaluación"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>FECHA DE EVALUACIÓN DESDE:</label>
          <p class="text-muted mt-2">{{ evalTest.date_start }}</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>FECHA DE EVALUACIÓN HASTA:</label>
          <p class="text-muted mt-2">{{ evalTest.date_end }}</p>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>4. TIPO DE EVALUACIÓN:</label>
          <p class="text-muted mt-2">Prueba</p>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>6. REUNIÓN INICIAL DESDE:</label>
          <app-input
            type="date"
            v-model="inputs.date_initial_meeting_from"
            :required="true"
            placeholder="Fecha desde"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>HORA DESDE:</label>
          <app-input
            type="time"
            v-model="inputs.time_initial_meeting_from"
            :required="true"
            placeholder="Hora desde"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>FECHA HASTA:</label>
          <app-input
            type="date"
            v-model="inputs.date_initial_meeting_to"
            :required="true"
            placeholder="Fecha hasta"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>HORA HASTA:</label>
          <app-input
            type="time"
            v-model="inputs.time_initial_meeting_to"
            :required="true"
            placeholder="Hora hasta"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>REUNIÓN FINAL HASTA:</label>
          <app-input
            type="date"
            v-model="inputs.date_final_meeting_from"
            :required="true"
            placeholder="Fecha desde"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>HORA DESDE:</label>
          <app-input
            type="time"
            v-model="inputs.time_final_meeting_from"
            :required="true"
            placeholder="Hora desde"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>FECHA HASTA:</label>
          <app-input
            type="date"
            v-model="inputs.date_final_meeting_to"
            :required="true"
            placeholder="Fecha hasta"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label>HORA HASTA:</label>
          <app-input
            type="time"
            v-model="inputs.time_final_meeting_to"
            :required="true"
            placeholder="Hora hasta"
          />
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>7. DATOS DEL EQUIPO EVALUADOR:</label>
          <table class="table table-sm table-striped text-center">
            <thead>
              <tr>
                <th scope="col" style="width: 33%">TIPO</th>
                <th scope="col" style="width: 34%">NOMBRE</th>
                <th scope="col" style="width: 33%">INSTITUCIÓN</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="reviewer">
                <td>Evaluador Líder</td>
                <td>
                  {{ reviewer.first_name }}
                  {{ reviewer.last_name }}
                </td>
                <td>{{ reviewer.institution }}</td>
              </tr>
              <tr v-for="(value, index) in evaluationTeam" :key="index">
                <td>{{ value.evaluator.evaluator_type.value }}</td>
                <td>{{ value.evaluator.full_name }}</td>
                <td>{{ value.evaluator.institution }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>8. TESTIFICACIONES A REALIZARSE:</label>
          <table class="table table-sm table-striped text-center">
            <thead>
              <tr>
                <th scope="col" style="width: 10%">#</th>
                <th scope="col" class="text-left">NOMBRE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, index) in testifications" :key="index">
                <td>{{ index + 1 }}</td>
                <td class="text-left">{{ value.code }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>FECHA DE ELABORACIÓN:</label>
          <app-input
            type="date"
            v-model="inputs.date_elaboration"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="mt-5">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import moment from "moment";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        place_evaluation: null,
        date_initial_meeting_from: null,
        time_initial_meeting_from: null,
        date_initial_meeting_to: null,
        time_initial_meeting_to: null,
        date_final_meeting_from: null,
        time_final_meeting_from: null,
        date_final_meeting_to: null,
        time_final_meeting_to: null,
        date_elaboration: new Date(),
      },
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest != null
        ? this.$store.state.evaluatorReview.evalTest
        : { code: "" };
    },
    evaluationTeam() {
      return this.$store.state.evaluatorReview.evalTest != null
        ? this.$store.state.evaluatorReview.evalTest.evaluation_team
        : [];
    },
    reviewer() {
      return this.$store.state.evaluatorReview.evalTest != null
        ? this.$store.state.evaluatorReview.evalTest.reviewer
        : null;
    },
    testifications() {
      return this.$store.state.evaluatorReview.evalTest != null
        ? this.$store.state.evaluatorReview.evalTest.testifications
        : [];
    },
    accApp() {
      return this.$store.state.evaluatorReview.evalTest
        .accreditation_applications != null
        ? this.$store.state.evaluatorReview.evalTest.accreditation_applications
        : {};
    },
    org() {
      return this.$store.state.evaluatorReview.evalTest
        .accreditation_applications != null
        ? this.$store.state.evaluatorReview.evalTest.accreditation_applications
            .organization
        : {
            name: "",
            canton: { name: "" },
            country: { name: "" },
            address: "",
            phone: "",
            email: "",
            legal_representative: "",
          };
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },
  created() {
    this.loadForm();
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      const data = {
        id: this.$store.state.evaluatorReview.evalTestId,
        place_evaluation: this.inputs.place_evaluation,
        initial_meeting_from:
          this.dateToString(this.inputs.date_initial_meeting_from) +
          " " +
          this.timeTo24(this.inputs.time_initial_meeting_from),
        initial_meeting_to:
          this.dateToString(this.inputs.date_initial_meeting_to) +
          " " +
          this.timeTo24(this.inputs.time_initial_meeting_to),
        final_meeting_from:
          this.dateToString(this.inputs.date_final_meeting_from) +
          " " +
          this.timeTo24(this.inputs.time_final_meeting_from),
        final_meeting_to:
          this.dateToString(this.inputs.date_final_meeting_to) +
          " " +
          this.timeTo24(this.inputs.time_final_meeting_to),
        date_elaboration: this.dateToString(this.inputs.date_elaboration),
      };
      this.save(data);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = res.data.data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest != null) {
        this.inputs.place_evaluation = this.$store.state.evaluatorReview.evalTest.place_evaluation;

        this.inputs.date_initial_meeting_from = this.stringToDate(
          this.$store.state.evaluatorReview.evalTest.initial_meeting_from
        );
        this.inputs.time_initial_meeting_from = this.timeTo12(
          this.$store.state.evaluatorReview.evalTest.initial_meeting_from
        );
        this.inputs.date_initial_meeting_to = this.stringToDate(
          this.$store.state.evaluatorReview.evalTest.initial_meeting_to
        );
        this.inputs.time_initial_meeting_to = this.timeTo12(
          this.$store.state.evaluatorReview.evalTest.initial_meeting_to
        );
        this.inputs.date_final_meeting_from = this.stringToDate(
          this.$store.state.evaluatorReview.evalTest.final_meeting_from
        );
        this.inputs.time_final_meeting_from = this.timeTo12(
          this.$store.state.evaluatorReview.evalTest.final_meeting_from
        );
        this.inputs.date_final_meeting_to = this.stringToDate(
          this.$store.state.evaluatorReview.evalTest.final_meeting_to
        );
        this.inputs.time_final_meeting_to = this.timeTo12(
          this.$store.state.evaluatorReview.evalTest.final_meeting_to
        );

        if (
          this.$store.state.evaluatorReview.evalTest.date_elaboration != null
        ) {
          this.inputs.date_elaboration = new Date(
            this.$store.state.evaluatorReview.evalTest.date_elaboration
          );
        }
      }
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },

    stringToDate(date) {
      return date != null ? new Date(date) : null;
    },

    timeTo24(time) {
      return time != null ? moment(time, ["h:mm A"]).format("HH:mm") : null;
    },

    timeTo12(date) {
      return date != null ? moment(date).format("hh:mm A") : null;
    },
  },
};
</script>
